/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	if (window.location.pathname.endsWith('/sitemap')) {
        // Add the title tag
        $('head').append('<title>Sitemap | Draw it Out</title>');
	}
	
	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});

	let shopifyCart = $('.shopify-buy-frame--toggle')
	let myCart = $('.my-cart')
	shopifyCart.insertAfter(myCart)


}); 



//Ol' Search
function getSearch() {
	document.getElementById('mobiSearchBox').style.display = 'flex';
	document.getElementById('mobiSearchBox').classList.add('search-active');
	document.querySelector('.overlaySearch').style.display = 'block';
  }

document.onclick = function closeSearch(e) {
	const searchbox = document.getElementById('mobiSearchBox');
	const searchIcon = document.querySelector('.mobiSearchIcon');
	const mobiSearch = document.getElementById('mobile-search');

	
	if (!searchbox.contains(e.target) && searchbox.classList.contains('search-active') && !searchIcon.contains(e.target) && !mobiSearch.contains(e.target)) {
	  searchbox.style.display = 'none';
	  document.querySelector('.overlaySearch').style.display = 'none';
	  document.getElementById('searchbox').classList.remove('search-active');
	}
  }

// Shopify search 
const baseUrl = 'https://drawliniment.com/search?type=product&q=';
const newSearch = document.getElementById('newSearch');
const searchIcon = document.querySelector('.search-icon')
const mobileSearch = document.getElementById('mobiNewSearch');
const mobileSearchIcon = document.querySelector('.mobiSearchIcon')
newSearch.addEventListener("keypress", enterSearch);
mobileSearch.addEventListener("keypress", enterSearch)
searchIcon.addEventListener('click', searchOffIcon);
mobileSearchIcon.addEventListener('click', mobileSearchOffIcon)

function enterSearch(event) {
	if (event.key === "Enter") {
		const input = event.target
		const newUrl = baseUrl + input.value;
		window.open(newUrl, '_self');
		event.preventDefault();
	}
}

function searchOffIcon(event) {
	const newUrl = baseUrl + newSearch.value;
	window.open(newUrl, '_self');
	event.preventDefault();
}

function mobileSearchOffIcon(event) {
	const newUrl = baseUrl + mobileSearch.value;
	window.open(newUrl, '_self');
	event.preventDefault();
}

const dropdowns = document.querySelectorAll('.is-dropdown-submenu-parent')
dropdowns.forEach(dropdown => {
	dropdown.addEventListener('mouseover', () => {
		document.querySelector('.overlaySearch').style.display = 'block';
		document.querySelector('.sticky-container').style.zIndex = '51'
})
})

dropdowns.forEach(dropdown => {
	dropdown.addEventListener('mouseleave', () => {
		document.querySelector('.overlaySearch').style.display = 'none';
		document.querySelector('.sticky-container').style.zIndex = '50'
})
})

var backToTopButton = document.querySelector('.back-to-top');

// Function to scroll to top
function scrollToTop() {
	window.scrollTo({ top: 0, behavior: 'smooth' });
}

// Add event listener to the button
backToTopButton.addEventListener('click', function(e) {
	e.preventDefault();
	scrollToTop();
});

function removeFrame() {
    var frames = document.querySelectorAll('.shopify-buy-frame iframe');
    frames.forEach(function(frame) {
        frame.removeAttribute('frameborder');
        frame.style.border = '0';
		frame.setAttribute('aria-label', 'shop')
    });
}

setTimeout(removeFrame, 3000)
